<template>
  <div>
    <h5>نامه ها</h5>
    <b-card
        v-if="tableData"
        no-body
        class="card-company-table"
    >
      <b-table
          :items="tableData"
          responsive
          :fields="fields"
          class="mb-0"
      >
        <!-- company -->
        <template #cell(company)="data">
          <div class="d-flex align-items-center cursor-pointer" @click="goToTicket(data.item.parentTicketId)">
            <div>
              <div class="font-weight-bolder">
                {{ data.item.title }}
              </div>
              <div class="font-small-2 text-muted">
                {{ data.item.creator.name }}
              </div>
            </div>
          </div>
        </template>

        <!-- category -->
        <template #cell(type)="data">
          <div class="d-flex align-items-center">
            <b-avatar
                class="mr-1"
                :variant="data.value.label"
            >
              <feather-icon
                  size="18"
                  :icon="data.value.icon"
              />
            </b-avatar>
            <span class="font-weight-bolder ml-1">{{ data.value.title }}</span>

          </div>
        </template>

        <!-- sales -->
        <template #cell(priority)="data">
          <div class="d-flex align-items-center">
            <feather-icon
                :icon="data.value.icon"
                :class="`text-${data.value.color}`"
            />
            <span class="font-weight-bolder ml-1">{{ data.value.title }}</span>

          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BTable, BAvatar, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BImg,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      fields: [
        { key: 'company', label: 'عنوان' },
        { key: 'type', label: 'نوع نامه' },
        { key: 'priority', label: 'درجه اهمیت' },
      ],
    }
  },
  methods:{
    goToTicket(ticketId){
      this.$router.push(`tickets/${ticketId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.card-company-table ::v-deep td .b-avatar.badge-light-company {
  .dark-layout & {
    background: $theme-dark-body-bg !important;
  }
}
</style>
